import { create } from 'zustand'
import type { PedidoStatusAlteradoPayload, PedidoCriadoPayload, PedidoCanceladoPayload } from '../services/websocketService'

type WebSocketCallback = {
  id: string
  callback: (data: any) => void
}

interface WebSocketStore {
  // Callbacks registrados por componentes
  pedidoCriadoCallbacks: WebSocketCallback[]
  pedidoStatusAlteradoCallbacks: WebSocketCallback[]
  pedidoCanceladoCallbacks: WebSocketCallback[]

  // Registrar callbacks
  onPedidoCriado: (id: string, callback: (data: PedidoCriadoPayload) => void) => void
  onPedidoStatusAlterado: (id: string, callback: (data: PedidoStatusAlteradoPayload) => void) => void
  onPedidoCancelado: (id: string, callback: (data: PedidoCanceladoPayload) => void) => void

  // Remover callbacks
  offPedidoCriado: (id: string) => void
  offPedidoStatusAlterado: (id: string) => void
  offPedidoCancelado: (id: string) => void

  // Disparar callbacks (chamado pelo useNotifications)
  triggerPedidoCriado: (data: PedidoCriadoPayload) => void
  triggerPedidoStatusAlterado: (data: PedidoStatusAlteradoPayload) => void
  triggerPedidoCancelado: (data: PedidoCanceladoPayload) => void

  // Limpar todos os callbacks
  clearAll: () => void
}

export const useWebSocketStore = create<WebSocketStore>((set, get) => ({
  pedidoCriadoCallbacks: [],
  pedidoStatusAlteradoCallbacks: [],
  pedidoCanceladoCallbacks: [],

  // Registrar callbacks
  onPedidoCriado: (id, callback) => {
    set((state) => ({
      pedidoCriadoCallbacks: [
        ...state.pedidoCriadoCallbacks.filter(c => c.id !== id),
        { id, callback }
      ]
    }))
  },

  onPedidoStatusAlterado: (id, callback) => {
    set((state) => ({
      pedidoStatusAlteradoCallbacks: [
        ...state.pedidoStatusAlteradoCallbacks.filter(c => c.id !== id),
        { id, callback }
      ]
    }))
  },

  onPedidoCancelado: (id, callback) => {
    set((state) => ({
      pedidoCanceladoCallbacks: [
        ...state.pedidoCanceladoCallbacks.filter(c => c.id !== id),
        { id, callback }
      ]
    }))
  },

  // Remover callbacks
  offPedidoCriado: (id) => {
    set((state) => ({
      pedidoCriadoCallbacks: state.pedidoCriadoCallbacks.filter(c => c.id !== id)
    }))
  },

  offPedidoStatusAlterado: (id) => {
    set((state) => ({
      pedidoStatusAlteradoCallbacks: state.pedidoStatusAlteradoCallbacks.filter(c => c.id !== id)
    }))
  },

  offPedidoCancelado: (id) => {
    set((state) => ({
      pedidoCanceladoCallbacks: state.pedidoCanceladoCallbacks.filter(c => c.id !== id)
    }))
  },

  // Disparar callbacks
  triggerPedidoCriado: (data) => {
    const callbacks = get().pedidoCriadoCallbacks
    console.log(`🔔 [WebSocketStore] Disparando ${callbacks.length} callbacks para pedido:criado`)
    callbacks.forEach(({ callback }) => callback(data))
  },

  triggerPedidoStatusAlterado: (data) => {
    const callbacks = get().pedidoStatusAlteradoCallbacks
    console.log(`🔔 [WebSocketStore] Disparando ${callbacks.length} callbacks para pedido:status_alterado`)
    callbacks.forEach(({ callback }) => callback(data))
  },

  triggerPedidoCancelado: (data) => {
    const callbacks = get().pedidoCanceladoCallbacks
    console.log(`🔔 [WebSocketStore] Disparando ${callbacks.length} callbacks para pedido:cancelado`)
    callbacks.forEach(({ callback }) => callback(data))
  },

  // Limpar todos os callbacks
  clearAll: () => {
    set({
      pedidoCriadoCallbacks: [],
      pedidoStatusAlteradoCallbacks: [],
      pedidoCanceladoCallbacks: [],
    })
  },
}))
